/* 
import getDOMroot from '@/utils/getDOMroot'
*/

let getDOMroot=()=>{
    const rootElement = document.getElementById("hitpaw-online-root")
    if(!rootElement){
        console.warn('rootElement is invalid',rootElement)
    }
    return (rootElement)
}


export default getDOMroot